const RoleConstant = {};

RoleConstant.Admin = "Admin";
RoleConstant.CallCenterAdmin = "CallCenterAdmin";
RoleConstant.QualityMonitor = "QualityMonitor";
RoleConstant.TranslationVendor = "TranslationVendor";
RoleConstant.DataScientist = "DataScientist";
RoleConstant.Reviewer = "Reviewer";

export default RoleConstant;